import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORTS_REPORTING]: {
    url: '/company/:companyId/reports/reporting/',
  },
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING]: {
    url: '/company/:companyId/reports/reporting/:reportingId/',
  },
  [ModulesConfigMap[ModulesMap.REPORTS_REPORTING].GET_REPORT_REPORTING_PREVIEW]: {
    url: '/company/:companyId/reports/reporting/:reportingId/preview/',
  },
}
